export const SET_LOGGEDIN = 'SET_LOGGEDIN';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_USER_DETAILS = 'SET_USER_DETAILS'
export const SET_MENU_ITEMS = 'SET_MENU_ITEMS'
export const SET_SELLERCREATION = 'SET_SELLERCREATION'
export const SET_ACCOUNTTYPE = 'SET_ACCOUNTTYPE'
export const SET_BUYNOWPRODUCTS = 'SET_BUYNOWPRODUCTS'
export const SET_ACCOUNT_DETAILS = 'SET_ACCOUNT_DETAILS'
export const SET_REGION = 'SET_REGION'
export const SET_CURRENT_DELIVERY_ADDRESS = 'SET_CURRENT_DELIVERY_ADDRESS'